export default "__VITE_ASSET__6b2a1b57__"